import React from 'react'

import CatalogPageWithData from './data'

const CatalogPageRenderer = ({
  match: {
    params: {categoryIdStr}
  },
  ...otherProps
}) => {
  const categoryId = parseInt(categoryIdStr) || null
  return <CatalogPageWithData {...otherProps} activeCategoryId={categoryId}/>
}

export default CatalogPageRenderer
